import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=d3dcf16a&scoped=true&"
import script from "./TagFilter.vue?vue&type=script&lang=ts&"
export * from "./TagFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dcf16a",
  null
  
)

export default component.exports